/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";

const RichTextWithImage = (props) => {
    
    const {
        richtext,
        image,       //image is an image object with a url property
        side = "left",
        displayWidth,
        displayHeight,
        orientation,
    } = props || {};
    
    const classlist = `simplicity-richtext-wrap-image ${side} ${orientation}`;
    
    return (
        <div className='rich-text-display read-only'>
            {image &&
                <div
                    style={{
                        width: displayWidth,
                        height: displayHeight,
                    }}
                    className={classlist}
                >
                    <img
                        src={image.url}
                        alt={image?.alt || "SimpliCity image"}
                    />
                </div>
            }
            <RichTextPreview richtext={richtext} />
        </div>
    );
};

export { RichTextWithImage };
